export default {"src":"/_next/static/media/login_icon.94c6c5ef.svg","height":26,"width":27,"blurWidth":0,"blurHeight":0};